/**
 * @file This file contains the configuration for ambient flying animal effects.
 * @module ambientAnimalsConfig
 */

export const ambientAnimalsConfig = {
    // The lower the number, the more frequent the event.
    // Chance to start is roughly 1/frequency per turn.
    frequency: 80,
    // How long the "flock" event lasts, in turns.
    duration: 20,
    // List of all possible birds that can appear.
    animals: ['🕊️', '🦅','🐤','🦆','🐦','🐉','🦋','🐝'],
    particle: {
        // How many birds to spawn during the event.
        count: 3,
        // All birds will traverse the screen.
        movement: 'traverse',
        // Base speed for movement.
        baseSpeed: 2,
        // Slight vertical drift.
        wind: 0.2,
        // Depth range for 3D effect (scaling and speed).
        depthMin: 0.5,
        depthMax: 3.0,
        // Chance to spawn a new particle each frame during an active flock event.
        spawnChanceDuringFlock: 0.05
    }
};